import * as React from "react";
import "./Table.css";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddIcon from "@mui/icons-material/Add";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import { Menu, MenuItem, Modal } from "@mui/material";
import ContactDetailList from "../ContactDetailList/ContactDetailList";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import RightSidebar from "../../RightSiderbar/RightSiderbar";
import axios from "axios";
import { ClearIcon } from "@mui/x-date-pickers";
import Loader from "../../Loader/Loader";
import { toast } from "react-toastify";
import hoveridentifier from "../../../Assets/hoverindentifier.svg";
import moment from "moment";
import sortingarrow from "../../../Assets/sortingarrow.svg";
import sortingimg from "../../../Assets/sortingarrow.svg";
import syncsorting from "../../../Assets/syncsorting.svg";
import SouthIcon from "@mui/icons-material/South";
import NorthIcon from "@mui/icons-material/North";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg";
import {
  APIUrlOne,
  APIUrlThree,
  APIUrlToken,
  APIUrlTwo,
  getConfidenceScore,
  GetOktaAuthData,
  GetUserId,
} from "../../../Utils/Utils";
import * as XLSX from "xlsx";
import { useState } from "react";
import IndustryDropdown from "../IndustrySectorDropdown/Index";
import starRed from "../../../Assets/starRed.svg";
import stargray from "../../../Assets/Stargrey.png";
import LeadsProspectModal from "../../RequestUpdateModals/LeadsProspectModal";
import MessageModal from "../../MessageModal/MessageModal";
import AddToFavoriteOrgModal from "../../FavoritesList/AddToFavoriteModal/AddToFavoriteOrgModal";
import SalesForceMessageModal from "../../MessageModal/SalesForceMessageModal";
import ProspectRequestModal from "../../RequestUpdateModals/ProspectRequestModal";
import { Card, CardContent, Typography, Chip, Grid } from "@mui/material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import VisibilityIcon from "@mui/icons-material/Visibility";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import MobileIndustrySectorDropdown from "../IndustrySectorDropdown/MobileIndustrySectorDropdown";
import MLeadsProspectsInnerTable from "./MLeadsProspectsInnerTable";
import addusermobile from "../../../Assets/addusermobile.svg";
function Row({
  key,
  row,
  onSelect,
  ExpandHandler,
  expandHandlerAccept,
  selectedRows,
  setSelectedRows,
  setPageInner,
  pageInner,
  openRowId,
  hasMoreInner,
  onLoadApi,
  setHasMoreInner,
  setopenRowId,
  totalPages,
  setRowsSelectOuter,
  setDisableTracking,
  selectedOuterRows,
  favoritesList,
  setFavoritesList,
  listFavoriteRecords,
  handleRowSelect,
  archivesProspectList,
  tableCommingData,
  handleApply,
  disableInner,
  isTabletLandscape,
}) {
  const [hasMoreInnerTable, setHasMoreInnerTable] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [innerTableData, setInnerTAbleData] = React.useState([]);
  const innerTableJsonData = innerTableData;
  const [open, setOpen] = React.useState(false);
  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [dataShortestPath, setDataShortestPath] = React.useState();
  const [strengthTableData, setStrengthTableData] = React.useState([]);
  const [userDetails, setUserDetails] = useState();
  const [scrollPagination, setScrollPagination] = useState(false);

  const loggedInUserId = GetUserId();
  const userIdNumber = parseInt(loggedInUserId);
  const handleRightsidebar = (event) => {
    const data = {};
    data.source_uid = Number(loggedInUserId);
    data.target_uid = Number(event?.person_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/shortest-path`,
    };
    axios(option)
      .then((response) => {
        if (response?.status === 200) {
          const data = Object.values(response.data);
          setDataShortestPath(data);
          setOpenSidebar(true);
          setUserDetails(event);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const getColor = (aiScore) => {
    if (aiScore > 80) {
      return "green";
    } else if (aiScore >= 50 && aiScore <= 80) {
      return "yellow";
    } else {
      return "red";
    }
  };
  const color = getColor(row.ai_score);
  const [rowsSelect, setRowsSelect] = useState(false);

  const handleAllSelectCollapsible = () => {
    if (rowsSelect) {
      const newList = innerTableData?.map((info) => ({
        ...info,
        organizationInfo: row,
      }));
      setSelectedRows(newList);
    } else {
      setSelectedRows([]);
    }
  };

  const onExpand = (event) => {
    setLoading(true);
    onLoadApi(event)
      .then((e) => {
        const childData = e;
        getStrength(childData, true);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const ExpandHandlerChild = (event) => {
    setLoading(true);
    ExpandHandler(event)
      .then((e) => {
        const childData = e;
        getStrength(childData);

        setLoading(false);
        if (e?.status === 200) {
          const innerdata = e?.data?.data;
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    if (expandHandlerAccept?.length > 0) {
      setInnerTAbleData([...expandHandlerAccept]);
    }
  }, [expandHandlerAccept]);

  const getStrength = async (childData, isExpand) => {
    if (!childData?.length) {
      setLoading(false);
      return;
    }
    setLoading(true);

    const tuples = childData?.map((item) => ({
      // items: [Number(loggedInUserId), item.person_id],
      items: [loggedInUserId?.toString(), item.person_id?.toString()],
    }));
    const data = { tuples };
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlTwo()}/v1/conn_strength`,
    };

    try {
      const response = await axios(options);
      const strengthData = response?.data;

      const updatedData = childData?.map((item, index) => ({
        ...item,
        strengthData: strengthData[index],
      }));

      if (isExpand) {
        setInnerTAbleData([...updatedData]);
      } else {
        setInnerTAbleData([...innerTableData, ...updatedData]);
      }

      if (open) {
      } else {
        setOpen(!open);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setTimeout(() => {
        setLoading(false);
        setScrollPagination(true);
      }, 0);
      setTimeout(() => {
        setHasMoreInner(true);
      }, 1000);
    }
  };

  const clickHandler = (event) => {
    navigate(`/companyprofilescreen/${event?.org_id}/0`);
  };

  React.useEffect(() => {
    if (
      innerTableData?.length >= 50 &&
      row.org_id === openRowId &&
      pageInner > 1 &&
      pageInner <= Math.ceil(pages)
    ) {
      setHasMoreInner(false);
      ExpandHandlerChild(openRowId);
    }
  }, [pageInner]);

  const isChecked = (id) => {
    return selectedRows.some((info) => info.person_id === id);
  };

  const pages = row.people_count / 50;
  const closeExpandHandler = () => {
    setInnerTAbleData([]);
    setOpen(false);
    setopenRowId("");
    setScrollPagination(false);
  };

  React.useEffect(() => {
    handleAllSelectCollapsible();
  }, [rowsSelect]);
  const ref = React.useRef(null);
  const isBranchLocationsDisabled = true;

  const loadMore = () => {
    setLoading(true);
    setPageInner((prevPageInner) => prevPageInner + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  // new add to fav api
  const handleFavouriteLead = (row) => {
    setLoading(true);

    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: [row.org_id],
      url: `${APIUrlThree()}/favorites/org/add-record?user_id=${loggedInUserId}`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        handleApply();
        toast.success(response.data?.message);
        // if (response?.data?.already_existing.length) {
        //   toast.error(response.data.already_existing[0].message);
        // } else {
        //   toast.success(response.data?.message);
        // }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // old add to fav api
  // const handleFavouriteLead = (row) => {
  //   setLoading(true)
  //   const data = {
  //     "user_id": Number(GetUserId()),
  //     "leads_id": row.org_id
  //   }
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APIUrlToken()
  //     },
  //     data: data,
  //     url: `${APIUrlThree()}/v1/save_favourite_leads`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       listFavoriteRecords()
  //       toast.success("Organization added to favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }

  // new remove rec api
  const handleRemoveFavouriteLead = (row) => {
    const data = tableCommingData?.find((item) => item?.org_id == row?.org_id);
    setLoading(true);
    const option = {
      method: "DELETE",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/favorites/delete_favorites_org?user_id=${loggedInUserId}`,
      data: [data.org_id],
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        // listFavoriteRecords()
        toast.success("Organization removed from favorites");
        handleApply();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // old remove fav rec api
  // const handleRemoveFavouriteLead = (row) => {
  //   const data = favoritesList?.find(item => item?.org_id == row?.org_id)
  //   setLoading(true)
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APIUrlToken()
  //     },
  //     url: `${APIUrlThree()}/v1/remove_favourite_leads?id=${data?.favourites_id}`,
  //   };
  //   axios(option)
  //     .then(async (response) => {
  //       setLoading(false);
  //       listFavoriteRecords()
  //       toast.success("Organization removed from favorites")
  //     })
  //     .catch(() => {
  //       setLoading(false);
  //     });
  // }

  const sortedDataInner = innerTableData
    ?.filter(
      (item) =>
        !archivesProspectList?.some((i) => i?.person_id === item?.person_id),
    )
    ?.sort((a, b) => {
      // First, sort by decision_maker
      if (a.decision_maker && !b.decision_maker) return -1;
      if (!a.decision_maker && b.decision_maker) return 1;

      // Then, sort by strengthData.strength in descending order
      return (b.strengthData?.strength || 0) - (a.strengthData?.strength || 0);
    });

  return (
    <React.Fragment key={key}>
      {loading ? <Loader /> : null}
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ cursor: "pointer" }}
      >
        <>
          <TableCell className="checkbox-row-table-inner checkbox-row-table">
            <div className="kjhgf">
              <input
                type="checkbox"
                disabled={disableInner === "No"}
                onChange={() => handleRowSelect(row)}
                checked={selectedOuterRows.some(
                  (item) => item.org_id === row?.org_id,
                )}
              />
            </div>
          </TableCell>
          {/* <TableCell
            component="th"
            scope="row"
          >
            <>

              {
                row?.isFavourite ? (
                  <div className="kjhgf" onClick={() => handleRemoveFavouriteLead(row)}>
                    <img src={starRed} alt="Star Red" />
                  </div>
                ) : (
                  <div className="kjhgf" onClick={() => handleFavouriteLead(row)}>
                    <img src={stargray} alt="Star Gray" />
                  </div>
                )
              }
            </>
          </TableCell> */}
          <TableCell
            component="th"
            scope="row"
            onClick={() => clickHandler(row)}
          >
            <div className="kjhgf">
              <div
                className="ai-score-background"
                style={{
                  background:
                    color === "red"
                      ? "#DA291C"
                      : color === "yellow"
                        ? "#EAB121"
                        : color === "green"
                          ? "#0EB93E"
                          : null,
                }}
              >
                {/* {row.ai_score ? row.ai_score : "-"} */}
                {row?.ai_score !== null && row?.ai_score !== undefined
                  ? row?.ai_score
                  : "NA"}
              </div>
            </div>
          </TableCell>
          <TableCell
            align="left"
            className="companylocation"
            onClick={() => clickHandler(row)}
          >
            <h3 className="company-name-country-prospect">
              {row.name ? row.name : "-"}
            </h3>
            <p className="after-company-name-country-prospect">
              {row.location_identifiers ? row.location_identifiers : "-"}
            </p>
          </TableCell>
          <TableCell align="center" onClick={() => clickHandler(row)}>
            <div className="section-employee-size">
              <h3 className="employee-size-table">
                {row.num_employees ? row.num_employees : "-"}
              </h3>
            </div>
          </TableCell>
          <TableCell align="left" onClick={() => clickHandler(row)}>
            <h3 className="annual-revenue-table">
              {row?.revenue_range ? row?.revenue_range : "-"}
            </h3>
          </TableCell>
          <TableCell
            align="left"
            className="table-cell-of-contact-details-dropdown-th"
          >
            <div
              className="Set-dropdown-ofIndustry"
              style={{ position: "relative" }}
            >
              <div className="email-andrelative-other-info">
                <div className="maked-component-of-dropdown-forai-leads">
                  <IndustryDropdown row={row} />
                </div>
              </div>
            </div>
          </TableCell>
        </>
        <TableCell align="left" onClick={() => clickHandler(row)}>
          <h3 className="employee-size-table">
            {row.people_count ? row.people_count : "-"}
          </h3>
        </TableCell>
        <TableCell className="collapse-expand-main-header">
          <Tooltip title={open ? "Collapse" : "Expand"}>
            {open ? (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => closeExpandHandler()}
                className="button-collapse-table-main"
              >
                <RemoveRoundedIcon className="icon-collapse-table" />
              </IconButton>
            ) : (
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => {
                  setInnerTAbleData([]);
                  setHasMoreInner(false);
                  setTimeout(() => {
                    if (openRowId !== row?.org_id) {
                      setLoading(true);
                      setPageInner(1);
                      onExpand(row?.org_id);
                    }
                  }, 0);
                }}
                className="button-collapse-table-main"
              >
                <AddIcon className="icon-collapse-table" />
              </IconButton>
            )}
          </Tooltip>
        </TableCell>
        <TableCell>
          <td style={{ position: "relative" }}>
            {" "}
            {/* Ensures proper positioning */}
            <div className="hover-container-prospects">
              <img
                src={hoveridentifier}
                alt=""
                className="hover-image-prospects"
              />

              <div
                className={`hover-content-prospects ${
                  !row?.updated_at || !row?.confidence_score
                    ? "no-update-prospects"
                    : "has-update-prospects"
                }`}
              >
                <div className="data-sync-c-rate-prospects">
                  <div className="datasync-line-c-score-prospects">
                    <span className="datasync-line-prospects">Data Sync: </span>
                    <span className="datasync-line-data-prospects">
                      {row?.updated_at
                        ? moment(row.updated_at).format("MM.DD.YY")
                        : "No update information available"}
                    </span>
                  </div>
                  <div className="datasync-line-c-score-prospects">
                    <span className="datasync-line-prospects">
                      Data Confidence Score:
                    </span>
                    <span className="datasync-line-data-prospects">
                      {row?.confidence_score
                        ? getConfidenceScore(row.confidence_score)
                        : "No update information available"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </TableCell>
      </TableRow>
      {innerTableData?.length ? (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box
                sx={{ margin: 1 }}
                id="scrollableDiv"
                className="ai-leads-table-inner"
                ref={ref}
              >
                <TableContainer component={Paper}>
                  <Table
                    aria-label="collapsible table"
                    className="ai-leads-table"
                  >
                    <TableHead>
                      <TableRow className="row-head">
                        <TableCell className="checkbox-row-table-inner checkbox-row-table">
                          <input
                            type="checkbox"
                            disabled={disableInner === "Yes"}
                            onChange={(e) => setRowsSelect(e?.target?.checked)}
                            checked={rowsSelect}
                          />
                        </TableCell>
                        <TableCell className="empty-name-and-title"></TableCell>

                        <TableCell className="company-row-table-inner-name-and-other">
                          <p className="title-name-inner-lead-table">
                            Name & Title{" "}
                          </p>
                        </TableCell>
                        <TableCell
                          align="left"
                          className="score-row-table-New-Data"
                        >
                          JOI Strength
                        </TableCell>
                        <TableCell
                          align="left"
                          className="employee-row-table-innerIndustryAndSector"
                        >
                          <p className="sector-industry"> Industry/ Sector</p>
                        </TableCell>
                        {isTabletLandscape ? (
                          ""
                        ) : (
                          <TableCell
                            align="left"
                            className="annual-row-table-NewJOSFStatus"
                          >
                            JOSF Status
                          </TableCell>
                        )}
                        <TableCell
                          align="left"
                          className="industry-row-table-inner-table"
                        >
                          Contact details
                        </TableCell>
                        <TableCell
                          align="left"
                          className="industry-row-table-inner-table-last"
                        ></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sortedDataInner?.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            No Records Available
                          </TableCell>
                        </TableRow>
                      ) : (
                        sortedDataInner?.map((item, index) => {
                          const firstName = item?.first_name;
                          const lastName = item?.last_name;
                          const decision_maker = item.decision_maker === true;
                          const concatedName = `${
                            firstName
                              ? firstName
                                  ?.split(" ")
                                  ?.find((item) => !item.includes("("))
                                  ?.charAt(0)
                              : ""
                          }${
                            lastName
                              ? lastName
                                  ?.split(" ")
                                  ?.find((item) => !item.includes("("))
                                  ?.charAt(0)
                              : ""
                          }`;

                          const isSelected = isChecked(item.person_id);
                          return (
                            <React.Fragment key={index}>
                              <TableRow
                                key={index}
                                sx={{ "& > *": { borderBottom: "unset" } }}
                              >
                                <TableCell className="checkbox-row-table">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => onSelect(item)}
                                    disabled={disableInner === "Yes"}
                                  />
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className="empty-name-and-title"
                                >
                                  <div className="name-title-inner-table-ofAi-leads">
                                    <div className="relation-section-inner">
                                      <div
                                        className={
                                          decision_maker
                                            ? "decision-maker-class"
                                            : "create-name-img"
                                        }
                                      >
                                        <p className="name-heading">
                                          {concatedName}
                                        </p>
                                        <img
                                          className={
                                            item.suspect_status === null
                                              ? "hide-image"
                                              : "../images/salesforce-logo.svg"
                                          }
                                          src={
                                            item?.journey_status ===
                                            "project created"
                                              ? activeSaleforceLogo
                                              : "../images/salesforce-logo.svg"
                                          }
                                          alt=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className="company-row-table-inner-name-and-other"
                                  onClick={() =>
                                    navigate(`/Profile/${item?.person_id}`)
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="name-title-inner-table-ofAi-leads">
                                    <div className="relation-section-inner">
                                      <div className="name-and-designation">
                                        <p className="name-in-acordian">{`${
                                          item?.first_name === "jp"
                                            ? "JP"
                                            : item?.first_name || "-"
                                        } ${item?.last_name || "-"}`}</p>

                                        <div className="job-title-container">
                                          <div className="tooltip-container-jobtitle">
                                            <p
                                              className={
                                                item?.raw_job_title
                                                  ? "tooltip-highlights-jobtitle"
                                                  : "tooltip-highlights-jobtitle-none"
                                              }
                                            >
                                              <p>{item?.raw_job_title}</p>
                                            </p>
                                            <p className="designation-in-acordian">
                                              {item?.primary_job_title?.length
                                                ? item?.primary_job_title
                                                    .length > 20
                                                  ? item?.primary_job_title.substr(
                                                      0,
                                                      20,
                                                    ) + "..."
                                                  : item?.primary_job_title
                                                : "-"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <p className="j-strength-cell">
                                    {item?.strengthData?.strength || "-"}
                                  </p>
                                </TableCell>
                                <TableCell
                                  align="left"
                                  className="table-cell-of-contact-details-dropdown-th"
                                >
                                  <div
                                    className="Set-dropdown-ofIndustry"
                                    style={{ position: "relative" }}
                                  >
                                    <div className="email-andrelative-other-info">
                                      <div className="maked-component-of-dropdown-forai-leads">
                                        <IndustryDropdown row={item} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                {isTabletLandscape ? (
                                  ""
                                ) : (
                                  <TableCell align="left">
                                    <div className="suspect-and-arrow-in-accordian">
                                      <p>{item?.suspect_status || "-"}</p>
                                    </div>
                                  </TableCell>
                                )}
                                <TableCell
                                  align="left"
                                  className="table-cell-of-contact-details-dropdown-th"
                                >
                                  <div
                                    className="Set-dropdown-ofContactDetailList"
                                    style={{ position: "relative" }}
                                  >
                                    <div className="email-and-other-infodc">
                                      <div className="maked-component-of-dropdown">
                                        <ContactDetailList item={item} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className="left-arrow-main-cell-container">
                                  <IconButton
                                    className="egberh"
                                    aria-label="expand row"
                                    size="small"
                                  >
                                    <RightSidebar
                                      handleRightsidebar={handleRightsidebar}
                                      rowid={item}
                                      dataShortestPath={dataShortestPath}
                                      openSidebar={openSidebar}
                                      userDetails={userDetails}
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })
                      )}

                      {/* {sortedDataInner?.map((item, index) => {
                          const firstName = item?.first_name;
                          const lastName = item?.last_name;
                          const decision_maker = item.decision_maker === true;
                          const concatedName = `${firstName
                            ? firstName
                              ?.split(" ")
                              ?.find((item) => !item.includes("("))
                              ?.charAt(0)
                            : ""
                            }${lastName
                              ? lastName
                                ?.split(" ")
                                ?.find((item) => !item.includes("("))
                                ?.charAt(0)
                              : ""
                            }`;

                          const isSelected = isChecked(item.person_id);
                          return (
                            <React.Fragment key={index}>
                              <TableRow key={index} sx={{ "& > *": { borderBottom: "unset" } }}>
                                <TableCell className="checkbox-row-table">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    onChange={() => onSelect(item)}
                                    disabled={disableInner === "Yes"}
                                  />
                                </TableCell>
                                <TableCell align="left" className="empty-name-and-title">
                                  <div className="name-title-inner-table-ofAi-leads">
                                    <div className="relation-section-inner">
                                      <div
                                        className={
                                          decision_maker
                                            ? "decision-maker-class"
                                            : "create-name-img"
                                        }
                                      >
                                        <p className="name-heading">{concatedName}</p>
                                        <img
                                          className={
                                            item.suspect_status === null
                                              ? "hide-image"
                                              : "../images/salesforce-logo.svg"
                                          }
                                          src={
                                            item?.journey_status === "project created"
                                              ? activeSaleforceLogo
                                              : "../images/salesforce-logo.svg"
                                          } alt=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align="left" className="company-row-table-inner-name-and-other" onClick={() => navigate(`/Profile/${item?.person_id}`)} style={{ cursor: "pointer" }}>
                                  <div className="name-title-inner-table-ofAi-leads">
                                    <div className="relation-section-inner">
                                      <div className="name-and-designation">
                                        <p className="name-in-acordian">{`${item?.first_name === "jp" ? "JP" : item?.first_name || "-"} ${item?.last_name || "-"}`}</p>

                                        <div className="job-title-container">
                                          <div className="tooltip-container-jobtitle">
                                            <p className={item?.raw_job_title ? "tooltip-highlights-jobtitle" : "tooltip-highlights-jobtitle-none"}>
                                              <p>{item?.raw_job_title}</p>
                                            </p>
                                            <p className="designation-in-acordian">
                                              {item?.primary_job_title?.length
                                                ? item?.primary_job_title.length > 20
                                                  ? item?.primary_job_title.substr(0, 20) + "..."
                                                  : item?.primary_job_title
                                                : "-"}
                                            </p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  <p className="j-strength-cell">
                                    {item?.strengthData?.strength || "-"}
                                  </p>
                                </TableCell>
                                <TableCell align="left" className="table-cell-of-contact-details-dropdown-th">
                                  <div className="Set-dropdown-ofIndustry" style={{ position: "relative" }}>
                                    <div className="email-andrelative-other-info">
                                      <div className="maked-component-of-dropdown-forai-leads">
                                        <IndustryDropdown row={item} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align="left">
                                  <div className="suspect-and-arrow-in-accordian">
                                    <p>{item?.suspect_status || "-"}</p>
                                  </div>
                                </TableCell>
                                <TableCell align="left" className="table-cell-of-contact-details-dropdown-th">
                                  <div className="Set-dropdown-ofContactDetailList" style={{ position: "relative" }}>
                                    <div className="email-and-other-infodc">
                                      <div className="maked-component-of-dropdown">
                                        <ContactDetailList item={item} />
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className="left-arrow-main-cell-container">
                                  <IconButton
                                    className="egberh"
                                    aria-label="expand row"
                                    size="small"
                                  >
                                    <RightSidebar
                                      handleRightsidebar={handleRightsidebar}
                                      rowid={item}
                                      dataShortestPath={dataShortestPath}
                                      openSidebar={openSidebar}
                                      userDetails={userDetails}
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        })} */}
                    </TableBody>
                  </Table>
                </TableContainer>
                {innerTableData?.length >= 50 ? (
                  <div className="loadmore-pagination-section">
                    {totalPages !== pageInner && (
                      <button
                        className="btn-load-more button-loadmore-pagination"
                        onClick={loadMore}
                        disabled={loading}
                      >
                        {loading ? "Loading..." : "Load More"}
                      </button>
                    )}
                  </div>
                ) : null}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null}
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default function AiLeadsTable({
  trackingData,
  tableCommingData,
  istableDataFilter,
  setCurrentLeadsLength,
  setIstableDataFilter,
  setIsDecisionMakerExcel,
  isDecisionMakerExcel,
  isSalesForceTrigger,
  handleApply,
  setPage,
  page,
  archiveRecord,
  setArchiveRecord,
  trackRecord,
  setTrackRecord,
  requestUpdateRecord,
  setRequestUpdateRecord,
  setDisableRequestUpdate,
  profileRecords,
  setProfileRecords,
  applyFilterProfile,
  selectedProfile,
  selectedOuterRows,
  setSelectedOuterRows,
  setShowSalesForce,
  totalPagesout,
  setDisableTracking,
  handleTrackingdata,
  setAddToFav,
  addToFav,
  setIsSalesForceTrigger,
  isMobile,
  isTabPortrait,
  handleSort,
  sortOrder,
  sortField,
  data,
  setData,
  isTabletLandscape,
}) {
  const userInfo = GetOktaAuthData();
  const loggedUser = userInfo?.user?.profile;
  const exportToExcel = (data, filename) => {
    const filteredData = data.map(
      ({ person_id, org_id, strengthData, ...rest }) => rest,
    );
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${filename}.xlsx`);
    setIsDecisionMakerExcel(false);
  };
  const [loading, setLoading] = React.useState(false);
  const [jsonData, setJsonData] = React.useState([]);
  const [hasMore, setHasMore] = React.useState(false);
  const [hasMoreInner, setHasMoreInner] = React.useState(false);
  // const [page, setPage] = React.useState(0);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [expandHandlerAccept, setExpandHandlerAccept] = useState([]);
  const [pageInner, setPageInner] = React.useState(1);
  const [openRowId, setopenRowId] = useState("");
  const perPage = 50;
  const [totalPages, setTotalPages] = useState(10);
  const [rowsSelectOuter, setRowsSelectOuter] = React.useState({});
  const [favoritesList, setFavoritesList] = React.useState([]);
  const [archivesList, setArchivesList] = React.useState([]);
  const [archivesProspectList, setArchivesProspectList] = React.useState([]);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [messageModalSalesforce, setMessageModalSalesforce] =
    React.useState(false);
  const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
  const [successModel, setSuccessModel] = useState("");
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const [disableInner, setDisableInner] = useState("");
  React.useEffect(() => {
    if (tableCommingData) {
      setJsonData(tableCommingData);
    }
  }, [tableCommingData]);
  React.useEffect(() => {
    if (selectedOuterRows?.length) {
      setDisableInner("Yes");
    } else if (selectedRows?.length) {
      setDisableInner("No");
    } else {
      setDisableInner("");
    }
  }, [selectedOuterRows, selectedRows]);
  React.useEffect(() => {
    setTimeout(() => {
      if (profileRecords === true) {
        applyFilterProfile();
      } else if (selectedProfile?.id && profileRecords == false) {
      } else if (tableCommingData?.length) {
        handleApply();
      } else {
        handleApply();
        // aiLeadsTable();
      }
    }, 150);
  }, [page, profileRecords, selectedProfile]);
  React.useEffect(() => {
    if (jsonData) {
      setCurrentLeadsLength(jsonData?.length);
      // const favorite = jsonData?.filter(item => item?.favourite_id !==null && item?.favourite_id)?.map(item => item?.id)
      // setFavoritesList(favorite)
    }
  }, [jsonData]);
  React.useEffect(() => {
    if (isDecisionMakerExcel) {
      if (!selectedOuterRows?.length && !selectedRows?.length) {
        toast.error("Please select records to download");
        setIsDecisionMakerExcel(false);
        return;
      }
      exportToExcel(
        selectedOuterRows.length ? selectedOuterRows : selectedRows,
        "aileads_exported_data",
      );
      // exportToExcel(selectedRows, "aileads_exported_data")
    }
  }, [isDecisionMakerExcel]);
  const validateSalesforce = () => {
    if (!selectedRows || selectedRows?.length === 0) {
      toast.error("Please Select Records For Push To Salesforce");
      return false;
    }
    return true;
  };
  const ExpandHandler = (event, page) => {
    setopenRowId(event);

    const option = {
      method: "GET",
      headers: {
        "content-type": "plain/text",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/decision_maker?org_id=${event}&limit=50&skip=${
        (pageInner - 1) * 50
      }`,
    };
    return axios(option).then((e) => {
      if (e?.status === 200) {
        setTotalPages(10);
        const innerdata = e?.data?.data;
        if (innerdata?.length === 0) {
          setHasMoreInner(false);
        }
        return innerdata;
      }

      return e;
    });
  };
  const onLoadApi = (event) => {
    setopenRowId(event);

    const option = {
      method: "GET",
      headers: {
        "content-type": "plain/text",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/decision_maker?org_id=${event}&limit=50&skip=${0}`,
    };
    return axios(option).then((e) => {
      if (e?.status === 200) {
        const innerdata = e?.data?.data;
        if (innerdata?.length === 0) {
          setHasMoreInner(false);
        } else {
        }
        return innerdata;
      }

      return e;
    });
  };
  React.useEffect(() => {
    if (isSalesForceTrigger) {
      if (!validateSalesforce()) return;
      setMessageModalSalesforce(true);
    }
  }, [isSalesForceTrigger]);
  const loadMore = () => {
    setLoading(true);
    setPage((page) => page + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const handleRowSelect = (row) => {
    setSelectedOuterRows((prevSelectedRows) => {
      const isAlreadySelected = prevSelectedRows.some(
        (item) => item.org_id === row.org_id,
      );

      if (isAlreadySelected) {
        return prevSelectedRows.filter((item) => item.org_id !== row.org_id);
      } else {
        return [...prevSelectedRows, row];
      }
    });
  };
  React.useEffect(() => {
    if (disableInner === "Yes" || disableInner === "") {
      if (selectedOuterRows?.length < 1 && requestUpdateRecord == true) {
        setDisableRequestUpdate(false);
        setRequestUpdateRecord(false);
        toast.error("Please select record to request update");
        return;
      } else if (
        selectedOuterRows?.length === 1 &&
        requestUpdateRecord == true
      ) {
        setRequestUpdateModal(true);
        setRequestUpdateRecord(false);
        setDisableRequestUpdate(false);
      } else if (selectedOuterRows?.length > 1 && requestUpdateRecord == true) {
        setDisableRequestUpdate(false);
        setRequestUpdateRecord(false);
        toast.error("Please select only one record to request update");
      } else {
        setDisableRequestUpdate(false);
      }
    }
  }, [selectedOuterRows, requestUpdateRecord]);
  React.useEffect(() => {
    if (disableInner === "No" || disableInner === "") {
      if (selectedRows?.length === 1 && requestUpdateRecord == true) {
        setRequestUpdateModal(true);
        setRequestUpdateRecord(false);
        setDisableRequestUpdate(false);
      } else if (selectedRows?.length > 1 && requestUpdateRecord == true) {
        setDisableRequestUpdate(false);
        setRequestUpdateRecord(false);
        toast.error("Please select only one record to request update");
      } else {
        setDisableRequestUpdate(false);
      }
    }
  }, [selectedRows, requestUpdateRecord]);
  const handleTrackRecords = () => {
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to track");
      setTrackRecord(false);
      return;
    } else {
      setLoading(true);

      const filteredData = selectedOuterRows.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.org_id) === Number(trackingItem.org_id),
          ),
      );

      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }

      const data = filteredData.map((item) => item?.org_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_organization?user_id=${Number(
          GetUserId(),
        )}`,
      };

      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            toast.success("Tracking Added");
            setTrackRecord(false);
            setMessageModalTrack(false);
            setSelectedOuterRows([]);
            setDisableTracking(true);
            handleTrackingdata();
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };
  const handleTrackRecordsInner = (item) => {
    if (!selectedRows?.length) {
      toast.error("Please select records to track");
      setTrackRecord(false);
      return;
    } else {
      setLoading(true);
      const filteredData = selectedRows.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.person_id) === Number(trackingItem.person_id),
          ),
      );

      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }

      const data = filteredData.map((item) => item?.person_id);

      // const data = selectedOuterRows.map(item => item?.person_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_prospect?user_id=${Number(
          GetUserId(),
        )}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            setTrackRecord(false);
            toast.success("Tracking Added");
            setSelectedRows([]);
            setMessageModalTrack(false);
            setDisableTracking(true);
            handleTrackingdata();
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };
  // const handleTrackRecords = () => {
  //   if (!selectedOuterRows?.length) {
  //     toast.error("Please select records to track")
  //     setTrackRecord(false)
  //     return
  //   } else {
  //     setLoading(true);
  //     const data = selectedOuterRows.map(item => item?.org_id);
  //     const option = {
  //       method: "POST",
  //       headers: {
  //         "access-control-allow-origin": "*",
  //         "X-API-Key": APIUrlToken()
  //       },
  //       data: data,
  //       url: `${APIUrlThree()}/v1/save_tracking_organization?user_id=${Number(GetUserId())}`,
  //     };
  //     axios(option)
  //       .then((response) => {
  //         if (response.status === 200) {
  //           setLoading(false);
  //           toast.success("Tracking Added")
  //           setTrackRecord(false)
  //           setMessageModalTrack(false)
  //           setSelectedOuterRows([])
  //         }
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //         toast.error(error.response.data.message);
  //       });
  //   }
  // }
  React.useEffect(() => {
    if (trackRecord == true) {
      if (!selectedOuterRows?.length && !selectedRows?.length) {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      }
      setMessageModalTrack(true);
      setTrackRecord(false);
    }
  }, [trackRecord]);
  React.useEffect(() => {
    if (addToFav == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to Add To Favorites");
        setAddToFav(false);
        return;
      }
      setOpenCreateListmdl(true);
      setAddToFav(false);

      // handleTrackRecords()
    }
  }, [addToFav]);
  const handleRemoveFavouriteLead = (row) => {
    setLoading(true);
    const data = favoritesList?.find((item) => item?.org_id == row?.org_id);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      // data: data,
      url: `${APIUrlThree()}/v1/remove_favourite_leads?id=${
        data?.favourites_id
      }`,
    };
    axios(option)
      .then(async (response) => {
        setLoading(false);
        // toast.success("Organization removed from favorites")
      })
      .catch(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    if (archiveRecord == true) {
      if (!selectedOuterRows?.length && !selectedRows?.length) {
        toast.error("Please select records to archive");
        setArchiveRecord(false);
        return;
      }
      setMessageModal(true);
      setArchiveRecord(false);
    }
  }, [archiveRecord]);
  const handleArchiveRecords = async () => {
    setLoading(true);
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to archive");
      setArchiveRecord(false);
      return;
    }

    await Promise.all(
      selectedOuterRows.map((i) => handleRemoveFavouriteLead(i)),
    );

    const data = selectedOuterRows.map((item) => ({
      user_id: Number(GetUserId()),
      org_id: item?.org_id,
      // people_id: item?.org_id,
    }));

    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      data: data,
      url: `${APIUrlThree()}/v1/send_archive`,
    };

    try {
      const response = await axios(options);

      setArchiveRecord(false);
      setMessageModal(false);
      setSelectedOuterRows([]);
      listFavoriteRecords();
      if (response?.data?.message === "Already archived") {
        toast.success("Organization already archived.");
      } else {
        toast.success("Organization archived successfully.");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error?.response?.data?.message || "Failed to archive organization.",
      );
    }
  };
  const handleArchiveRecordsInner = async () => {
    setLoading(true);
    if (!selectedRows?.length) {
      toast.error("Please select records to archive");
      setArchiveRecord(false);
      return;
    } else {
      await Promise.all(selectedRows.map((i) => handleRemoveFavouriteLead(i)));
      const data = selectedRows.map((item) => ({
        user_id: Number(GetUserId()),
        people_id: item?.person_id,
      }));

      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/send_archive`,
      };
      try {
        const response = await axios(options);
        setMessageModal(false);
        setArchiveRecord(false);
        setSelectedRows([]);
        if (response?.data?.message === "Already archived") {
          toast.success("Prospects already Archived.");
        } else {
          listFavoriteRecords();
          toast.success("Prospects Archived Successfully");
        }
        listArchiveProspectsRecords();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      } finally {
      }
    }
  };

  const listFavoriteRecords = async (e) => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_favourite_leads?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      setFavoritesList(response?.data?.data);
      if (e == 1) {
      } else {
        setLoading(false);
      }
      // setArchiveRecord(false)
      // toast.success("Prospects Archived Successfully")
    } catch (error) {
      setLoading(false);
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  const listArchiveRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_user_archive_leads?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      const data = response?.data?.data?.filter(
        (item) => item?.org_id !== null,
      );
      setArchivesList(data);
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  const listArchiveProspectsRecords = async () => {
    const options = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/list_user_archive_prospects?userid=${Number(
        GetUserId(),
      )}&limit=200&offset=0`,
    };
    try {
      const response = await axios(options);
      const data = response?.data?.data?.filter(
        (item) => item?.org_id !== null,
      );
      setArchivesProspectList(data);
    } catch (error) {
      // setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      // setLoading(false);
    }
  };
  React.useEffect(() => {
    listArchiveProspectsRecords();
  }, []);

  React.useEffect(() => {
    listFavoriteRecords(1);
    listArchiveRecords();
  }, []);
  React.useEffect(() => {
    if (selectedRows?.length) {
      const data = selectedRows?.filter((item) => item.suspect_status !== null);
      if (data?.length) {
        setShowSalesForce("disable");
      } else {
        setShowSalesForce("show");
      }
    } else {
      setShowSalesForce(false);
    }
  }, [selectedRows]);

  React.useEffect(() => {
    setData(jsonData);
  }, [jsonData]);

  React.useEffect(() => {
    if (data?.length) {
      handleSort("ai_score", "desc");
    }
  }, [data?.length]);

  const getColor = (aiScore) => {
    if (aiScore > 80) {
      return "green";
    } else if (aiScore >= 50 && aiScore <= 80) {
      return "yellow";
    } else {
      return "red";
    }
  };
  const navigate = useNavigate();
  const [openTableDrawer, setOpenTableDrawer] = useState();
  const clickHandler = (event) => {
    navigate(`/companyprofilescreen/${event?.org_id}/0`);
  };
  return (
    <React.Fragment>
      {loading ? <Loader /> : null}
      {isMobile || isTabPortrait ? (
        <>
          <div div className="isMobile-isTabPortrait">
            {data && data.length > 0 ? (
              <>
                {" "}
                {data?.map((row, index) => (
                  <Card
                    sx={{
                      borderRadius: 3,
                      boxShadow: 2,
                      p: 2,
                      position: "relative",
                      mb: 2,
                      background: selectedOuterRows?.some(
                        (item) => item?.org_id === row?.org_id,
                      )
                        ? "#c0dae6"
                        : "#fff",
                    }}
                  >
                    {/* Top Section */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                    >
                      <Box>
                        <Typography
                          onClick={() => handleRowSelect(row)}
                          variant="h6"
                          fontWeight="bold"
                          sx={{ textTransform: "capitalize", fontSize: 16 }}
                        >
                          {row.name ? row.name : "-"}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ textTransform: "capitalize" }}
                        >
                          {row.location_identifiers
                            ? row.location_identifiers
                            : "-"}
                        </Typography>
                      </Box>
                      <IconButton>{/* <StarBorderIcon /> */}</IconButton>
                    </Box>

                    {/* Score + Icons */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      mt={1}
                    >
                      <div style={{ width: "100%", display: "flex" }}>
                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            textAlign: "left",
                          }}
                        >
                          <div className="kjhgf">
                            <div
                              className="ai-score-background"
                              style={{
                                background:
                                  getColor(row.ai_score) === "red"
                                    ? "#DA291C"
                                    : getColor(row.ai_score) === "yellow"
                                      ? "#EAB121"
                                      : getColor(row.ai_score) === "green"
                                        ? "#0EB93E"
                                        : null,
                              }}
                            >
                              {/* {row.ai_score ? row.ai_score : "-"} */}
                              {row?.ai_score !== null &&
                              row?.ai_score !== undefined
                                ? row?.ai_score
                                : "NA"}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            width: "50%",
                            display: "flex",
                            textAlign: "right",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Box display="flex" gap={1}>
                            <IconButton
                              sx={{ color: "red", border: "1px solid #cbc9c9" }}
                            >
                              <VisibilityIcon
                                style={{ color: "#DA291C" }}
                                onClick={() => clickHandler(row)}
                              />
                            </IconButton>
                            <IconButton
                              sx={{ color: "red", border: "1px solid #cbc9c9" }}
                              onClick={() => setOpenTableDrawer(row)}
                            >
                              <img src={addusermobile} alt="" />
                            </IconButton>
                          </Box>
                        </div>
                      </div>
                    </Box>
                    {/* Info Grid */}
                    <Grid container spacing={2} mt={0}>
                      <Grid item xs={isMobile ? 6 : 9}>
                        <Typography variant="body2" color="text.secondary">
                          Employee Size
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {row.num_employees ? row.num_employees : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={isMobile ? 6 : 3}>
                        <Typography variant="body2" color="text.secondary">
                          Annual Revenue
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {row?.revenue_range ? row?.revenue_range : "-"}
                        </Typography>
                      </Grid>

                      <Grid item xs={isMobile ? 6 : 9}>
                        <Typography variant="body2" color="text.secondary">
                          Industry/Sector
                        </Typography>
                        <MobileIndustrySectorDropdown row={row} />
                      </Grid>

                      <Grid item xs={isMobile ? 6 : 3}>
                        <Typography variant="body2" color="text.secondary">
                          Employees
                        </Typography>
                        <Typography variant="subtitle2" fontWeight="bold">
                          {row.people_count ? row.people_count : "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                ))}
                <div className="loadmore-pagination-section">
                  {totalPagesout !== page && (
                    <button
                      className="btn-load-more button-loadmore-pagination"
                      onClick={loadMore}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="ai-leads-table-main">
                  <div className="ai-leads-no-data-available-outter">
                    <div className="ai-leads-no-data-available">
                      No Data Available
                    </div>
                  </div>
                </div>
              </>
            )}{" "}
            <MLeadsProspectsInnerTable
              selectedRows={selectedRows}
              onSelect={(selectedRow) => {
                const isAlreadySelected = selectedRows.some(
                  (row) => row?.person_id === selectedRow?.person_id,
                );
                let updatedRows;
                if (isAlreadySelected) {
                  updatedRows = selectedRows.filter(
                    (row) => row?.person_id !== selectedRow?.person_id,
                  );
                } else {
                  updatedRows = [...selectedRows, selectedRow];
                }
                const updatedOrganizations = updatedRows.map((row) => {
                  const organization = jsonData.find(
                    (org) => org?.org_id === row?.org_id,
                  );
                  return {
                    ...row,
                    organizationInfo: organization,
                  };
                });
                setSelectedRows(updatedOrganizations);
              }}
              isTabPortrait={isTabPortrait}
              openTableDrawer={openTableDrawer}
              setOpenTableDrawer={setOpenTableDrawer}
            />
          </div>
        </>
      ) : (
        <>
          {jsonData?.length ? (
            <>
              <TableContainer component={Paper} className="ai-leads-table-main">
                <Table
                  aria-label="collapsible table"
                  className="ai-leads-table"
                >
                  <TableHead>
                    <TableRow className="table-row-ai-leads">
                      <TableCell className="score-row-table">Select</TableCell>
                      {/* <TableCell className="score-row-table">Favorite</TableCell> */}
                      <TableCell className="score-row-table">
                        <p className="prospect-Name-and-Title-leads">
                          JOI Score {""}
                          {sortField === "ai_score" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("ai_score")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("ai_score")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("ai_score")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}{" "}
                        </p>{" "}
                      </TableCell>
                      <TableCell align="left" className="company-row-table">
                        <p className="Organization-location-leads">
                          Organization & location {""}
                          {sortField === "name" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("name")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("name")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("name")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}
                        </p>{" "}
                      </TableCell>
                      <TableCell align="left" className="employee-row-table">
                        <p className="Organization-location-leads">
                          Employee size {""}
                          {sortField === "num_employees" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("num_employees")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("num_employees")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("num_employees")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}
                        </p>
                      </TableCell>
                      <TableCell align="left" className="annual-row-table">
                        <p className="Organization-location-leads">
                          Annual revenue {""}
                          {sortField === "revenue_range" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("revenue_range")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("revenue_range")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("revenue_range")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}
                        </p>
                      </TableCell>
                      <TableCell align="left" className="industry-row-table">
                        <p className="sector-industry-inner-new">
                          {" "}
                          Industry/ Sector {""}
                          {sortField === "categories" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("categories")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("categories")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("categories")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}
                        </p>
                      </TableCell>
                      <TableCell align="left" className="industry-row-table">
                        <p className="industry-row-Inner">
                          Employees {""}
                          {sortField === "people_count" ? (
                            sortOrder === "asc" ? (
                              <NorthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("people_count")}
                              />
                            ) : (
                              <SouthIcon
                                style={{ fontSize: "10px", cursor: "pointer" }}
                                onClick={() => handleSort("people_count")}
                              />
                            )
                          ) : (
                            <img
                              src={sortingimg}
                              alt=""
                              onClick={() => handleSort("people_count")}
                              className="sorting-arrow-leadsprofile"
                            />
                          )}{" "}
                        </p>
                      </TableCell>
                      <TableCell align="left" className=""></TableCell>
                      <TableCell>
                        {sortField === "updated_at" ? (
                          sortOrder === "asc" ? (
                            <NorthIcon
                              className="sync-sorting-img-d-maker"
                              onClick={() => handleSort("updated_at")}
                            />
                          ) : (
                            <SouthIcon
                              className="sync-sorting-img-d-maker"
                              onClick={() => handleSort("updated_at")}
                            />
                          )
                        ) : (
                          <img
                            src={syncsorting}
                            alt=""
                            onClick={() => handleSort("updated_at")}
                            className="sync-sorting-img"
                          />
                        )}
                        {/* <img src={syncsorting} alt="" className="sync-sorting-img" /> */}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data
                      ?.filter(
                        (item) =>
                          !archivesList?.some(
                            (i) => i?.org_id === item?.org_id,
                          ),
                      )
                      ?.map((row, index) => {
                        const isSelected = selectedRows?.find(
                          (item) => item?.person_id === row?.person_id,
                        );
                        return (
                          <React.Fragment key={index}>
                            <Row
                              key={row.name}
                              row={row}
                              selected={isSelected}
                              onSelect={(selectedRow) => {
                                const localRows = [...selectedRows];
                                const selectedIndex = localRows.findIndex(
                                  (row) =>
                                    row?.person_id === selectedRow?.person_id,
                                );
                                let newSelected = [];
                                if (selectedIndex === -1) {
                                  newSelected = [selectedRow];
                                } else if (selectedIndex === 0) {
                                  newSelected = newSelected.concat(
                                    localRows.slice(1),
                                  );
                                } else if (
                                  selectedIndex ===
                                  localRows.length - 1
                                ) {
                                  newSelected = newSelected.concat(
                                    localRows.slice(0, -1),
                                  );
                                } else if (selectedIndex > 0) {
                                  newSelected = localRows.filter(
                                    (child) =>
                                      child.person_id !== selectedRow.person_id,
                                  );
                                }
                                const updatedOrganizations = newSelected.map(
                                  (name) => {
                                    const organization = jsonData.find(
                                      (org) => org?.org_id === name?.org_id,
                                    );
                                    return {
                                      ...name,
                                      organizationInfo: organization,
                                    };
                                  },
                                );
                                setSelectedRows(
                                  selectedIndex > -1
                                    ? updatedOrganizations
                                    : [
                                        ...selectedRows,
                                        ...updatedOrganizations,
                                      ],
                                );
                              }}
                              connectionStrength={row.connectionStrength}
                              ExpandHandler={ExpandHandler}
                              onLoadApi={onLoadApi}
                              expandHandlerAccept={expandHandlerAccept}
                              selectedRows={selectedRows}
                              setSelectedRows={setSelectedRows}
                              setPageInner={setPageInner}
                              pageInner={pageInner}
                              openRowId={openRowId}
                              hasMoreInner={hasMoreInner}
                              setExpandHandlerAccept={setExpandHandlerAccept}
                              setHasMore={setHasMore}
                              setopenRowId={setopenRowId}
                              setHasMoreInner={setHasMoreInner}
                              totalPages={totalPages}
                              setRowsSelectOuter={setRowsSelectOuter}
                              selectedOuterRows={selectedOuterRows}
                              favoritesList={favoritesList}
                              setFavoritesList={setFavoritesList}
                              listFavoriteRecords={listFavoriteRecords}
                              handleRowSelect={handleRowSelect}
                              archivesProspectList={archivesProspectList}
                              tableCommingData={tableCommingData}
                              handleApply={handleApply}
                              disableInner={disableInner}
                              isTabletLandscape={isTabletLandscape}
                            />
                          </React.Fragment>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <div className="loadmore-pagination-section">
                {totalPagesout !== page && (
                  <button
                    className="btn-load-more button-loadmore-pagination"
                    onClick={loadMore}
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Load More"}
                  </button>
                )}
              </div>
            </>
          ) : (
            <div className="ai-leads-table-main">
              <div className="ai-leads-no-data-available-outter">
                <div className="ai-leads-no-data-available">
                  No Data Available
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {selectedOuterRows?.length ? (
        <MessageModal
          open={messageModal}
          setOpen={setMessageModal}
          message={
            selectedOuterRows?.length > 0
              ? `Are you sure that you want to archive ${
                  selectedOuterRows?.length > 1
                    ? "these organizations"
                    : "this organization"
                }?`
              : `Are you sure that you want to archive ${
                  selectedRows?.length > 1 ? "these Prospects" : "this Prospect"
                } ?`
          }
          handleSubmit={handleArchiveRecords}
          // favoritesList={favoritesList}
          // listFavoriteRecords={listFavoriteRecords}
          length={
            selectedOuterRows?.length > 0
              ? selectedOuterRows?.length
              : selectedRows?.length
          }
        />
      ) : (
        <MessageModal
          open={messageModal}
          setOpen={setMessageModal}
          message={
            selectedOuterRows?.length > 0
              ? `Are you sure that you want to archive ${
                  selectedOuterRows?.length > 1
                    ? "these organizations"
                    : "this organization"
                }?`
              : `Are you sure that you want to archive ${
                  selectedRows?.length > 1 ? "these Prospects" : "this Prospect"
                } ?`
          }
          handleSubmit={handleArchiveRecordsInner}
          // favoritesList={favoritesList}
          // listFavoriteRecords={listFavoriteRecords}
          length={
            selectedOuterRows?.length > 0
              ? selectedOuterRows?.length
              : selectedRows?.length
          }
          selectedRows={selectedRows}
        />
      )}

      {selectedOuterRows?.length ? (
        <MessageModal
          open={messageModalTrack}
          setOpen={setMessageModalTrack}
          message={`Are you sure that you want to add ${
            selectedOuterRows?.length > 1 ? "these records" : "this record"
          } to tracking?`}
          handleSubmit={handleTrackRecords}
          length={selectedOuterRows?.length}
        />
      ) : (
        <MessageModal
          open={messageModalTrack}
          setOpen={setMessageModalTrack}
          message={`Are you sure that you want to add ${
            selectedRows?.length > 1 ? "these records" : "this record"
          } to tracking?`}
          handleSubmit={handleTrackRecordsInner}
          length={selectedRows?.length}
        />
      )}

      {/* <MessageModal open={messageModalSalesforce} setOpen={setMessageModalSalesforce} message={`Are you sure that you want to push ${selectedRows?.length > 1 ? "these records" : "this record"} to Salesforce?`} handleSubmit={pushToSalesForce} length={selectedRows?.length} /> */}
      <SalesForceMessageModal
        open={messageModalSalesforce}
        setOpen={setMessageModalSalesforce}
        selectedOuterRows={selectedRows}
        setSelectedOuterRows={setSelectedRows}
        decisionMakerData={jsonData}
        setLoading={setLoading}
        setIsSalesForceTrigger={setIsSalesForceTrigger}
      />
      {selectedOuterRows?.length ? (
        <LeadsProspectModal
          requestUpdateRecord={requestUpdateModal}
          setRequestUpdateRecord={setRequestUpdateModal}
          profileData={selectedOuterRows[0]}
          peopleId={selectedOuterRows?.[0]?.org_id}
          setSuccessModel={setSuccessModel}
          successModel={successModel}
          setSelectedOuterRows={setSelectedOuterRows}
        />
      ) : (
        <ProspectRequestModal
          requestUpdateRecord={requestUpdateModal}
          setRequestUpdateRecord={setRequestUpdateModal}
          profileData={selectedRows[0]}
          peopleId={selectedRows?.[0]?.person_id}
          setSelectedOuterRows={setSelectedRows}
          setSuccessModel={setSuccessModel}
          successModel={successModel}
        />
      )}

      <AddToFavoriteOrgModal
        open={openCreateListmdl}
        setOpen={setOpenCreateListmdl}
        selectedOuterRows={selectedOuterRows}
        setSelectedOuterRows={setSelectedOuterRows}
        message={`Are you sure that you want to add ${
          selectedOuterRows?.length > 1 ? "these records" : "this record"
        } to Favorites?`}
        handleApply={handleApply}
      />
      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon onClick={() => setSuccessModel(false)} />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                JOI team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>
    </React.Fragment>
  );
}
